import './polyfills';
import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import store from './store'
import App from './App'
import './assets/base.scss'
import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'video-react/dist/video-react.css'
import 'react-datepicker/dist/react-datepicker.css'
import 'react-image-lightbox/style.css'

ReactDOM.createRoot(document.getElementById('root')).render(
    <Provider store={store}>
      <App />
    </Provider>,
)
